import { render, staticRenderFns } from "./MsgSignReminderListItem.vue?vue&type=template&id=80ca9580&scoped=true"
import script from "./MsgSignReminderListItem.vue?vue&type=script&lang=js"
export * from "./MsgSignReminderListItem.vue?vue&type=script&lang=js"
import style0 from "./MsgSignReminderListItem.vue?vue&type=style&index=0&id=80ca9580&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ca9580",
  null
  
)

export default component.exports